import React from 'react';
import ChatWidget from './ChatWidget'; // ← Upravte podle umístění souboru
import CookieConsent from './CookieConsent';

type Props = {
  children: React.ReactNode
}

const Layout = ({ children }: Props) => {
  return (
    <div className="bg-white min-h-screen relative flex flex-col">
      <div className="max-w-7xl mx-auto px-4 w-full flex-1">
        {children}
      </div>
      
      {/* Globální chat ve spodním rohu */}
      <ChatWidget />
      
      {/* Cookies Banner */}
      <CookieConsent />
    </div>
  );
};

export default Layout;
